export default __webpack_public_path__ + "static/media/41_mobile.c305c5dc.jpg";